import { render, staticRenderFns } from "./DemoShow.vue?vue&type=template&id=0932c458&scoped=true"
import script from "./DemoShow.vue?vue&type=script&lang=ts"
export * from "./DemoShow.vue?vue&type=script&lang=ts"
import style0 from "./DemoShow.vue?vue&type=style&index=0&id=0932c458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932c458",
  null
  
)

export default component.exports